// Deriva la pantalla a mostrar a partir del resultado de getConfirmContext.
export function confirmScreenFromResult(result) {
  if (!result || !result.ok) {
    const reason = result && result.reason;
    if (reason === 'expired') return 'expired';
    if (reason === 'already_confirmed') return 'already';
    return 'invalid';
  }
  const hasSlots = (result.slots || []).some((p) => (p.available_slots || []).length > 0);
  return hasSlots ? 'choose' : 'taken';
}
